<template>
  <v-layout>
    <v-flex xs12>
      <v-sheet
        v-if="showBody"
        class="h100"
        color="lighten-3"
        :class="[$vuetify.breakpoint.smAndUp ? 'pa-6' : 'pa-3']"
      >
        <v-btn
          class="mr-1"
          fab
          dark
          x-small
          fixed
          right
          color="secondary"
          title="drucken"
          @click.stop="printDetail">
          <v-icon dark>mdi-printer</v-icon>
        </v-btn>
        <v-btn
          v-if="canLock"
          class="mr-10"
          fab
          dark
          x-small
          fixed
          right
          color="secondary"
          :title="data.webarc_hide === 0 ? 'sperren' : 'entsperren'"
          @click.stop="hideDoc">
          <v-icon dark>{{data.webarc_hide === 0 ? 'mdi-lock' : 'mdi-lock-open'}}</v-icon>
        </v-btn>
        <v-sheet v-if="showBody" class="detail-body">
          <v-sheet outlined class="grey--text mb-2 pr-12 pb-2">
            <small>
              <template v-if="isItem">
                <span class="first">Angezeigtes Dokument:</span> {{data.src_id}}
              </template>
              <template v-if="data.keywords">
                <span :class="{first: !isItem}">Schlagworte:</span> {{data.keywords}}
              </template>
              <br v-if="isItem">
              <span :class="{first: isItem}">Erschienen in:</span> {{data.svc_name}}
              <template v-if="data.prty">
                <span>Priorität:</span> {{data.prty}}
              </template>
              <span>am:</span> {{dateString(data.at)}}
              <template v-if="isItem">
                <span>Erscheinungsnummer:</span> {{data.msg_seq}}
              </template>
            </small>
          </v-sheet>
          <hr>
          <a v-if="data.url" :href="fileUrl + '/file' +  data.url + fileHash" target="_blank">
            <img v-if="data.thumbnail" :src="fileUrl + '/file' +  data.thumbnail" class="file-preview" />
          </a>
          <h1 class="my-3 detail-title" :class="[ data.thumbnail ? 'file-preview' : '']" v-html="headline"/>
          <h4 v-if="teaser" class="mb-4 font-italic font-weight-light" v-html="teaser"></h4>
          <div v-if="!isPdf" class="body-2 mt-4" v-html="body"/>
          <br v-if="!userAuthenticated">

          <v-alert :value="!userAuthenticated"
            type="info"
            border="left"
            color="grey"
            transition="scale-transition"
            dense>
            Melden Sie sich bitte an, um die ganze Meldung zu sehen.
          </v-alert>

          <br>
          <div class="body-2">© 1995-{{new Date().getFullYear()}} epd (Evangelischer Pressedienst). Nutzung nur im Rahmen der schriftlichen Vereinbarungen.</div>
        </v-sheet>
      </v-sheet>
    </v-flex>

    <v-dialog
      v-model="isProcessing"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <div class="text-center">
            Änderung wird gespeichert...
          </div>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
/* tslint:disable:no-console */
import { mapState } from 'vuex';
import * as he from 'he';

export default {
  data() {
    return {
      query: '',
    };
  },
  computed: {
    canLock() {
      return this.userTokenPayload && this.userTokenPayload.permissions ?
        this.userTokenPayload.permissions.indexOf('webarc.admin.*') >= 0 : false;
    },
    isItem() {
      return false; // customer seems unsure when exactly this should be shown, so we always hide for now
      // return this.data ? this.data.src_id.indexOf('pdf.') < 0 : false;
    },
    isPdf() {
      return this.data ? this.data.src_id.indexOf('pdf.') >= 0 : false;
    },
    data() {
      return this.$store.state.list.detail ? this.$store.state.list.detail : {};
    },
    fileUrl() {
      return process.env.VUE_APP_AUTH_URL;
    },
    fileHash() {
      let res = '';
      const params = [];
      if (this.data.headline.indexOf('(Seite') >= 0 || this.query.length > 0) {
        res += '#';
      }
      if (this.data.headline.indexOf('(Seite ') >= 0) {
        const page = this.data.headline.match(/\(([^)]+)\)/g)[0].replace('(Seite ', '').split('/')[0];
        params.push('page=' + page);
      }
      if (this.query.length > 0) {
        params.push('search=' + this.query);
      }
      return res + params.join('&');
    },
    showDetailId() {
      return this.$store.state.list.showDetailId;
    },
    headline() {
      if (this.data) {
        return this.highlight(this.data.headline);
      }
    },
    teaser() {
      if (this.data) {
        return this.highlight(this.data.teaser);
      }
    },
    showBody() {
      return this.body || this.teaser || this.data.thumbnail || this.data.headline;
    },
    body() {
      if (this.data && this.data.body) {
        // filter headline from body
        let body = this.data.body;
        const encode = true;
        if (!this.data.is_html && body.indexOf('=') >= 0) {
          body = body.split('\r\n');
          body.shift();
          body = body.join('\r\n').trim();
        }
        if (this.data.is_html) {
          body = body.replace(/\r?\n|\r/g, '');
        }
        return this.highlight(body, encode).split('\n').join('<br>');
      }
    },
    isProcessing: {
      get() {
        return this.$store.state.list.isProcessing;
      },
      set(val) {
        this.$store.commit('isProcessing', val);
      },
    },
    ...mapState({
      userAuthenticated: (state) => state.app.userAuthenticated,
      userTokenPayload: (state) => state.app.userTokenPayload,
    }),
  },
  mounted() {
    // fetch initial content
    if (this.$route.params.id) {
      this.$store.commit('showDetail', this.$route.params.id);
    }
  },
  watch: {
    data(item) {
      if (item) {
        document.title = this.$route.meta.title + ': ' + item.headline;
      }
    },
    showDetailId(id) {
      this.query = this.$store.state.list.filters.query;
      this.fetchDetail(id);
    },
    $route(to, from) {
      // fetch new content on route change
      if (to.name === 'detail' && to.params.id) {
        this.$store.commit('showDetail', to.params.id);
      }
    },
  },
  methods: {
    highlight(str, encode) {
      let res = str;
      // look at query and wrap the matching words in spans for highlighting
      const blacklist = ['AND', 'OR', 'NOT'];
      let query = this.query.replace(/["\/]/g, '').trim();
      if (!str || !query || !this.query) {
        return str;
      }
      if (encode) {
        query = he.encode(query, { useNamedReferences: true });
      }
      if (query.indexOf(' ') < 0 || this.query.indexOf('"') >= 0) {
        let regex;
        if (query === 'um' || query === 'Um') {
          regex = new RegExp(`[\\s+|^]${query}\\s+`, 'gi');
        } else {
          regex = new RegExp(query, 'gi');
        }
        res = str.replace(regex, (match) => {
            return '<span class="highlight">' + match + '</span>';
        });
      } else {
        const words = query.split(' ');
        words.forEach((word) => {
          if (word.length > 0 && blacklist.indexOf(word) < 0) {
            let regex;
            if (word === 'um' || word === 'Um') {
              regex = new RegExp(`(?![^<]*>)\\s+${word}\\s+`, 'gi');
            } else {
              regex = new RegExp('(?![^<]*>)' + word, 'gi');
            }
            res = res.replace(regex, (match) => {
              return '<span class="highlight">' + match + '</span>';
            });
          }
        });
      }
      return res;
    },
    dateString(sent) {
      const date = sent * 1000;
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      };
      return new Date(date).toLocaleTimeString('de-DE', options);
    },
    printDetail() {
      window.print();
    },
    hideDoc() {
      this.isProcessing = true;
      const data = {
        src_id: this.data.src_id,
        hide: this.data.webarc_hide === 0,
      };

      this.$store.dispatch('hideDoc', data)
        .then((res) => {
          this.fetchDetail(data.src_id).then(() => {
            this.isProcessing = false;
          });
        });
    },
    async fetchDetail(src_id) {
      if (src_id === null) {
        return this.$store.commit('populateItem', {});
      }
      const URL = process.env.VUE_APP_AUTH_URL;
      const response = await fetch(URL + '/api/detail', {
        method: 'POST',
        withCredentials: true,
        credentials: 'include',
        body: JSON.stringify({ src_id }),
        headers: {
            'Authorization': 'Bearer ' + this.$store.state.app.jwt,
            'Content-Type': 'application/json',
        },
      });
      try {
        if (response.status === 401) {
          this.$store.commit('setUserAuthenticated', false);
          this.$router.push('/');
        }
        const json = await response.json();
        if (json.item) {
          this.$store.commit('populateItem', json.item);
        }
        if (json.token) {
          this.$store.commit('setJWT', json.token);
        }
        document.getElementById('detail-panel').scrollTop = 0;
      } catch (err) {
        console.error(err);
        this.$store.commit('toggleDialog', {viz: true, msg: err.message});
      }
    },
  },
};
</script>

<style lang="less">
.v-alert {
  clear: both;
}
.highlight {
  background-color: yellow;
}
.authorline, .subline, .body-2 h1 {
  margin-bottom: 16px;
}
.subline {
  font-weight: bold;
}
.body-2 h1 {
  font-size: 1em;
}
.h100, #detail-panel, #detail-panel .layout, #detail-panel .layout .flex {
  height: 100%;
}
.v-sheet small span {
  color: #666;
}
.detail-body {
  hr {
    border: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
  .v-sheet.grey--text {
     span {
      padding-left: 5px;
      &.first {
        padding-left: 0;
      }
    }
  }
}
.detail-title.file-preview {
  float: left;
  width: calc(100% - 170px);
}
img.file-preview {
  float: right;
  width: 160px;
  margin: 10px 0;
}
.body-2 {
  clear: both;
}
@media screen and (max-width: 599px) {
  .detail-title {
    font-size: 24px;
  }
  .v-application--is-ltr {
    .v-data-footer__select, .v-data-footer__pagination {
      margin: 0;
      .v-select {
        margin-left: 10px;
        margin-right: 10px;
      }
    }
  }
}
</style>
